import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  tenantService,
  type TenantProfileUpdateInput,
} from '../../../services/TenantService';
import { tenantQueryKeys } from '../tenantQueryKeys';

export function useUpdateTenantProfileMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: TenantProfileUpdateInput) =>
      tenantService.updateProfile(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: tenantQueryKeys.profile(),
      });
    },
  });
}
